import React from 'react';

function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <h2>About Me</h2>
        <p>Passionate about AI/ML and skilled in Python, with a strong grasp of technical fundamentals and a collaborative mindset. Focused on utilizing technology to tackle intricate challenges and fostering positive working dynamics in collaborative settings.</p>
      </div>
    </section>
  );
}

export default About;
